// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
import { MaterialCatalog_AssetFragmentDoc } from '../../../../../../libraries/material-catalog/MaterialCatalog.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectProductModalProjectItemsQueryVariables = Types.Exact<{
  filter: Types.ProjectItemFilter;
  pageFilter: Types.PageFilter;
}>;


export type SelectProductModalProjectItemsQuery = { __typename?: 'Query', projectItemsPage: { __typename?: 'ProjectItemsPage', projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, allCommittedCostInCents: number, planBasedCostHoldingProjectItems: Array<{ __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type SelectProductModalMetadataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type SelectProductModalMetadataQuery = { __typename?: 'Query', projectCostCodes: { __typename?: 'ProjectCostCodesPageResult', entities: Array<{ __typename?: 'ProjectCostCode', id: string, costCode: { __typename?: 'CostCode', id: string, name: string } }> } };

export type SelectProductModalProjectItems_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, name: string, allCommittedCostInCents: number, planBasedCostHoldingProjectItems: Array<{ __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined };

export const SelectProductModalProjectItems_ProjectItemFragmentDoc = gql`
    fragment SelectProductModalProjectItems_ProjectItem on ProjectItem {
  id
  name
  allCommittedCostInCents
  planBasedCostHoldingProjectItems {
    id
    allCommittedCostInCents
  }
  location {
    id
    displayLocationPath
  }
  materialVariant {
    id
    displayName
    featuredImage {
      id
      asset {
        ...MaterialCatalog_Asset
      }
    }
    listing {
      id
      name
      brand {
        id
        name
      }
    }
  }
}
    ${MaterialCatalog_AssetFragmentDoc}`;
export const SelectProductModalProjectItemsDocument = gql`
    query SelectProductModalProjectItems($filter: ProjectItemFilter!, $pageFilter: PageFilter!) {
  projectItemsPage(filter: $filter, page: $pageFilter) {
    projectItems {
      ...SelectProductModalProjectItems_ProjectItem
    }
    pageInfo {
      totalCount
    }
  }
}
    ${SelectProductModalProjectItems_ProjectItemFragmentDoc}`;

/**
 * __useSelectProductModalProjectItemsQuery__
 *
 * To run a query within a React component, call `useSelectProductModalProjectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductModalProjectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductModalProjectItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageFilter: // value for 'pageFilter'
 *   },
 * });
 */
export function useSelectProductModalProjectItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables> & ({ variables: SelectProductModalProjectItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>(SelectProductModalProjectItemsDocument, options);
      }
export function useSelectProductModalProjectItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>(SelectProductModalProjectItemsDocument, options);
        }
// @ts-ignore
export function useSelectProductModalProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>;
export function useSelectProductModalProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectProductModalProjectItemsQuery | undefined, SelectProductModalProjectItemsQueryVariables>;
export function useSelectProductModalProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>(SelectProductModalProjectItemsDocument, options);
        }
export type SelectProductModalProjectItemsQueryHookResult = ReturnType<typeof useSelectProductModalProjectItemsQuery>;
export type SelectProductModalProjectItemsLazyQueryHookResult = ReturnType<typeof useSelectProductModalProjectItemsLazyQuery>;
export type SelectProductModalProjectItemsSuspenseQueryHookResult = ReturnType<typeof useSelectProductModalProjectItemsSuspenseQuery>;
export type SelectProductModalProjectItemsQueryResult = ApolloReactCommon.QueryResult<SelectProductModalProjectItemsQuery, SelectProductModalProjectItemsQueryVariables>;
export const SelectProductModalMetadataDocument = gql`
    query SelectProductModalMetadata($projectId: ID!) {
  projectCostCodes(filter: {project: [$projectId]}) {
    entities {
      id
      costCode {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useSelectProductModalMetadataQuery__
 *
 * To run a query within a React component, call `useSelectProductModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductModalMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSelectProductModalMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables> & ({ variables: SelectProductModalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>(SelectProductModalMetadataDocument, options);
      }
export function useSelectProductModalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>(SelectProductModalMetadataDocument, options);
        }
// @ts-ignore
export function useSelectProductModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>;
export function useSelectProductModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectProductModalMetadataQuery | undefined, SelectProductModalMetadataQueryVariables>;
export function useSelectProductModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>(SelectProductModalMetadataDocument, options);
        }
export type SelectProductModalMetadataQueryHookResult = ReturnType<typeof useSelectProductModalMetadataQuery>;
export type SelectProductModalMetadataLazyQueryHookResult = ReturnType<typeof useSelectProductModalMetadataLazyQuery>;
export type SelectProductModalMetadataSuspenseQueryHookResult = ReturnType<typeof useSelectProductModalMetadataSuspenseQuery>;
export type SelectProductModalMetadataQueryResult = ApolloReactCommon.QueryResult<SelectProductModalMetadataQuery, SelectProductModalMetadataQueryVariables>;